import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { environment } from '../../environments/environment';
import fetchData from '@helpers/fetchData';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class Http2Service {
  private baseUrl: string;
  constructor(private authService: AuthService) {
    this.baseUrl = environment.baseCpuUrl;
  }
  fetch(url: string, body: any) {
    const uri = this.buildUrl(url);

    return fetchData(this.authService, uri, body).pipe(
      catchError((err: any) => {
        if (err.error == 'TokenRevoked') {
          this.authService.performLocalLogout(true);
        }

        return throwError(() => err);
      })
    );
  }

  private buildUrl(url: string): string {
    return new URL(url, this.baseUrl).href;
  }
}
